__turbopack_context__.v({
  "container": "_2jPP-G_container",
  "icon": "_2jPP-G_icon",
});
